import { useDisclosure } from '@/hooks';
import { Button, ButtonProps } from 'antd';
import { WorkorderItem } from '../WorkOrderItemModal';
import WorkOrderItemHistoryModal from './WorkOrderItemHistoryModal';

interface Props extends ButtonProps {
  itemPart: WorkorderItem;
}

const WorkOrderItemHistoryButton: React.FC<Props> = ({
  itemPart,
  ...props
}) => {
  const [modalOpened, modalAction] = useDisclosure();

  return (
    <>
      <Button
        {...props}
        type="primary"
        className="--accent"
        onClick={modalAction.open}
      >
        Histórico
      </Button>

      <WorkOrderItemHistoryModal
        open={modalOpened}
        onCancel={modalAction.close}
        itemPart={itemPart}
      />
    </>
  );
};

export default WorkOrderItemHistoryButton;
